// Extracted verbatim from the v3 monolith (see BIRDSEYE.md module split plan).

import { DATA_FILTER } from './constants.js';
import { toArray, normalizeText } from './utils.js';
import { isNativeFormControl, getChipValue, getControlFilterValue, isChipActive, describeOption } from './controls.js';
import { showNode } from './ui-state.js';

export var _collectFacetCountDefs = function () {
  var self = this;
  this.facetCountDefs = [];

  this.facetCountNodes.forEach(function (node) {
    var field = normalizeText(
      node.getAttribute('data-pf-filter') ||
      node.getAttribute('data-pf-facet-field') ||
      ''
    );
    var value = normalizeText(
      node.getAttribute('data-pf-value') ||
      node.getAttribute('data-pf-facet-value') ||
      ''
    );

    if (!field || !value) {
      var host = node.closest('label, .w-checkbox, .w-radio, [data-pf-option], ' + DATA_FILTER);
      var control = host
        ? (host.matches(DATA_FILTER) ? host : host.querySelector(DATA_FILTER))
        : null;

      if (control) {
        field = field || normalizeText(control.getAttribute('data-pf-filter') || '');
        value = value || normalizeText(getControlFilterValue(control));
      }
    }

    if (!field || !value) {
      return;
    }

    var host = node.closest('[data-pf-facet-option], label, .w-checkbox, .w-radio, option');
    var control = null;
    var optionNode = null;
    var hideTarget = null;
    var targetSelector = node.getAttribute('data-pf-facet-target');

    if (node.matches(DATA_FILTER)) {
      control = node;
    } else if (host) {
      if (host.matches(DATA_FILTER)) {
        control = host;
      } else if (host.tagName && host.tagName.toLowerCase() === 'option') {
        optionNode = host;
        control = host.parentElement && host.parentElement.tagName.toLowerCase() === 'select'
          ? host.parentElement
          : null;
      } else {
        control = host.querySelector(DATA_FILTER);
      }
    }

    if (targetSelector) {
      hideTarget = self.wrapper.querySelector(targetSelector);
    } else if (host && host.tagName && host.tagName.toLowerCase() !== 'option') {
      hideTarget = host;
    } else if (optionNode) {
      hideTarget = optionNode;
    }

    self.facetCountDefs.push({
      node: node,
      field: field,
      value: value,
      control: control,
      optionNode: optionNode,
      hideTarget: hideTarget,
    });
  });

  if (this.facetHideEmpty || this.facetDisableEmpty) {
    var known = new Set(
      this.facetCountDefs.map(function (def) {
        return def.field + '::' + def.value;
      })
    );

    this.filterControls.forEach(function (control) {
      var field = normalizeText(control.getAttribute('data-pf-filter') || '');
      if (!field) {
        return;
      }

      var value = '';
      if (!isNativeFormControl(control)) {
        value = normalizeText(getChipValue(control));
      } else {
        var type = (control.type || '').toLowerCase();
        if (type !== 'checkbox' && type !== 'radio') {
          return;
        }
        value = normalizeText(getControlFilterValue(control));
      }

      if (!value || value === '*') {
        return;
      }

      var key = field + '::' + value;
      if (known.has(key)) {
        return;
      }
      known.add(key);

      var host = control.closest('[data-pf-facet-option], label, .w-checkbox, .w-radio');
      self.facetCountDefs.push({
        node: null,
        field: field,
        value: value,
        control: control,
        optionNode: null,
        hideTarget: host || control,
      });
    });
  }

  this._debugLog('facet-count:definitions', {
    count: this.facetCountDefs.length,
    mode: this.facetCountMode,
    hideEmpty: this.facetHideEmpty,
    disableEmpty: this.facetDisableEmpty,
  });
};

export var _buildFacetCountMap = function (source) {
  var counts = Object.create(null);

  source.forEach(function (record) {
    var fields = record.fields || {};

    Object.keys(fields).forEach(function (field) {
      var values = fields[field] || [];
      if (!values.length) {
        return;
      }

      var uniqueValues = Object.create(null);
      values.forEach(function (value) {
        if (!value || uniqueValues[value]) {
          return;
        }

        uniqueValues[value] = true;
        var key = field + '::' + value;
        counts[key] = (counts[key] || 0) + 1;
      });
    });
  });

  return counts;
};

export var _isFacetActive = function (def) {
  if (def.optionNode && def.control) {
    var select = def.control;
    if (select.multiple) {
      return !!def.optionNode.selected;
    }

    return normalizeText(select.value || '') === def.value;
  }

  if (!def.control) {
    return false;
  }

  if (!isNativeFormControl(def.control)) {
    return isChipActive(def.control);
  }

  var type = (def.control.type || '').toLowerCase();
  var tag = def.control.tagName.toLowerCase();

  if (type === 'checkbox' || type === 'radio') {
    return !!def.control.checked;
  }

  if (tag === 'select') {
    if (def.control.multiple) {
      return toArray(def.control.options).some(function (opt) {
        return opt.selected && normalizeText(opt.value) === def.value;
      });
    }

    return normalizeText(def.control.value || '') === def.value;
  }

  return normalizeText(def.control.value || '') === def.value;
};

export var _applyFacetOptionState = function (def, count) {
  var active = this._isFacetActive(def);
  var shouldCollapse = count === 0 && !active;

  if (this.facetHideEmpty && def.hideTarget) {
    if (def.optionNode && def.hideTarget === def.optionNode) {
      def.optionNode.hidden = shouldCollapse;
    } else {
      showNode(def.hideTarget, !shouldCollapse);
      // `hidden` alone loses to author CSS (Webflow's `.w-checkbox { display: … }`).
      def.hideTarget.style.display = shouldCollapse ? 'none' : '';
    }
  }

  if (!this.facetDisableEmpty) {
    return;
  }

  if (def.optionNode) {
    def.optionNode.disabled = shouldCollapse;
    return;
  }

  if (def.control) {
    if (!isNativeFormControl(def.control)) {
      def.control.setAttribute('aria-disabled', shouldCollapse ? 'true' : 'false');
      def.control.setAttribute('data-pf-disabled', shouldCollapse ? 'true' : 'false');
      return;
    }

    def.control.disabled = shouldCollapse;
    def.control.setAttribute('aria-disabled', shouldCollapse ? 'true' : 'false');
  }
};

// Marks every option that matches no item in the whole collection (e.g. a location with no
// vacancies) with facetEmptyClass, so the page can style or hide it with CSS. Static by
// design: it ignores the current selection, unlike `filtered` facet counts. Applied only
// once the dataset is complete — until then a value missing from the loaded pages may
// still sit on a page not fetched yet (or on one whose fetch failed). An active option is
// never marked, so CSS that hides empty options can never hide a checked filter the user
// then cannot uncheck.
export var _updateEmptyOptions = function () {
  if (!this.datasetComplete || this.failedPageUrls.size) {
    return;
  }

  var self = this;

  this.filterControls.forEach(function (control) {
    var option = describeOption(control);
    if (option) {
      option.target.classList.toggle(self.facetEmptyClass, !option.active && !self._optionHasItems(option));
    }
  });
};

// Whether selecting this option alone would show anything — same term and match mode as
// _collectState builds, checked against every loaded item.
export var _optionHasItems = function (option) {
  var self = this;
  return this.items.some(function (record) {
    return self._matchesField(record, option.field, [option.term]);
  });
};

// Items a field's counts come from in `filtered` mode: the current results with that
// field's OWN selection lifted, so each option shows what picking it would yield. Counting
// over the plain filtered results drops every sibling to 0 the moment one value is checked,
// and with hide/disable-empty that makes OR-within-a-field impossible. Under OR logic the
// other groups widen the result instead of narrowing it, so only search constrains.
export var _facetSourceItems = function (state, field) {
  if (!state) {
    return this.filteredItems;
  }

  var isOr = state.logic === 'or';
  if (!isOr && !state.filtersByField[field]) {
    return this.filteredItems;
  }

  var others = {};
  if (!isOr) {
    Object.keys(state.filtersByField).forEach(function (key) {
      if (key !== field) {
        others[key] = state.filtersByField[key];
      }
    });
  }

  return this._computeFilteredItems(Object.assign({}, state, { filtersByField: others }));
};

export var _updateFacetCounts = function (state) {
  if (!this.facetCountDefs.length) {
    return;
  }

  var isPartialGlobal =
    this.facetCountMode === 'global' &&
    this.facetAccuracy === 'partial' &&
    (!this.datasetComplete || this.failedPageUrls.size > 0);
  this.wrapper.setAttribute('data-pf-facet-partial', isPartialGlobal ? 'true' : 'false');

  var self = this;
  var mapsByField = Object.create(null);
  var globalMap = null;
  var countMapFor = function (field) {
    if (self.facetCountMode !== 'filtered') {
      globalMap = globalMap || self._buildFacetCountMap(self.items);
      return globalMap;
    }
    if (!mapsByField[field]) {
      mapsByField[field] = self._buildFacetCountMap(self._facetSourceItems(state, field));
    }
    return mapsByField[field];
  };

  this.facetCountDefs.forEach(function (def) {
    var key = def.field + '::' + def.value;
    var count = countMapFor(def.field)[key] || 0;

    if (def.node) {
      if (!def.node.hasAttribute('aria-live')) {
        def.node.setAttribute('aria-live', 'polite');
      }
      def.node.textContent = String(count);
    }
    this._applyFacetOptionState(def, count);
  }, this);
};

